import React from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';

import AcquistoImmobiliare from './acquistoImmobiliare';
import AttiSocietari from './attiSocietari';
import Successioni from './successioni';
import SoloInfoAgg from './soloInfoAgg';
import Mutuo from './mutuo';
import CessioneAffittoAzienda from './cessioneAffittoAzienda';
import Altro from './altro';
import Testamenti from './testamenti';
import FondoTrust from './fondoTrust';

export default function Preventivo(
    {
        tipoAtto,
        setTipoAtto,
        setPrezzodiacquisto,
        setAgevolazioniPrimaCasa,
        setRichiestaMutuo,
        setInfoAggiuntive,
        setVenditore,
        TipoSocietà,
        setTipoSocietà,
        setCapitaleSociale,
        TipoAttoSocieta,
        setTipoAttoSocieta,
        setNumeroCessioni,
        setElencoPrezziCessioni,
        setDescrizioneModifichePattiSociali,
        setDescrizioneOperazionePreventivo,
        setDescrizioneDelibereVerbalizzare,
        ComposizionePatrimonioEreditario,
        setComposizionePatrimonioEreditario,
        setImportoMutuo,
        setNomeBanca,
        setValoreIscrizioneIpotecaria,
        TipoAttoCessioneAffAzienda,
        setTipoAttoCessioneAffAzienda,
        setPrezzoVendita,
        setCanoneAffitto,
        setInfoPerPreventivo,
        ElencoPatrimonio,
        setElencoPatrimonio,
        ElencoEredi,
        setElencoEredi,
        ElencoBeni,
        setElencoBeni,
        setValoreAppBeni,
        setRenditaCatastale,
    }) {
    return (
		<>
            <MDBRow className='d-flex justify-content-center'>
                <MDBCol md='6' className='text-center'>
                    <div className="field">
                        <label className='customLab' >Tipologia Atto *</label>
                        <select onChange={e => setTipoAtto(e.target.value)} className="select">
                            <option default value='Acquisto immobiliare'>Acquisto immobiliare</option>
                            <option value='Mutuo'>Mutuo</option>
                            <option value='Atti societari'>Atti societari</option>
                            <option value='Cessione o affitto d’azienda'>Cessione o affitto d’azienda</option>
                            <option value='Successioni'>Successioni</option>
                            <option value='Testamenti'>Testamenti</option>
                            <option value='Convenzione matrimoniale'>Convenzione matrimoniale</option>
                            <option value='Fondo patrimoniale/Trust'>Fondo patrimoniale/Trust</option>
                            <option value='Impresa familiare'>Impresa familiare</option>
                            <option value='Altro'>Altro</option>
                        </select>
                    </div>
                </MDBCol>
            </MDBRow>
            <MDBRow className='d-flex justify-content-center'>
            <div className="d-flex justify-content-center"><h2>{tipoAtto}</h2></div>
            {(() => {
                if (tipoAtto === 'Acquisto immobiliare') {
                    return (
                        <AcquistoImmobiliare 
                            setPrezzodiacquisto = {setPrezzodiacquisto}
                            setAgevolazioniPrimaCasa = {setAgevolazioniPrimaCasa}
                            setRichiestaMutuo = {setRichiestaMutuo}
                            setInfoAggiuntive = {setInfoAggiuntive}
                            setVenditore = {setVenditore}
                            setRenditaCatastale = {setRenditaCatastale}
                        />
                    );
                }

                if (tipoAtto === 'Atti societari') {
                    return (
                        <AttiSocietari 
                            setInfoAggiuntive = {setInfoAggiuntive}
                        
                            setTipoSocietà={setTipoSocietà}
                            TipoSocietà={TipoSocietà}
                            setCapitaleSociale={setCapitaleSociale}
                            setTipoAttoSocieta={setTipoAttoSocieta}
                            TipoAttoSocieta={TipoAttoSocieta}
                            setNumeroCessioni={setNumeroCessioni}
                            setElencoPrezziCessioni={setElencoPrezziCessioni}
                            setDescrizioneModifichePattiSociali={setDescrizioneModifichePattiSociali}
                            setDescrizioneOperazionePreventivo={setDescrizioneOperazionePreventivo}
                            setDescrizioneDelibereVerbalizzare={setDescrizioneDelibereVerbalizzare}
                        />
                    );
                }

                if (tipoAtto === 'Successioni') {
                    return (
                        <Successioni 
                            setInfoAggiuntive = {setInfoAggiuntive}
                        
                            setComposizionePatrimonioEreditario={setComposizionePatrimonioEreditario}
                            ComposizionePatrimonioEreditario={ComposizionePatrimonioEreditario}
                        />
                    );
                }

                if (tipoAtto === 'Convenzione matrimoniale' | tipoAtto === 'Impresa familiare') {
                    return (
                        <SoloInfoAgg 
                            setInfoAggiuntive = {setInfoAggiuntive}
                        />
                    );
                }
                

                if (tipoAtto === 'Mutuo') {
                    return (
                        <Mutuo 
                            setInfoAggiuntive = {setInfoAggiuntive}
                            setImportoMutuo = {setImportoMutuo}
                            setNomeBanca = {setNomeBanca}
                            setValoreIscrizioneIpotecaria = {setValoreIscrizioneIpotecaria}
                        />
                    );
                }

                if (tipoAtto === 'Cessione o affitto d’azienda') {
                    return (
                        <CessioneAffittoAzienda 
                            setInfoAggiuntive = {setInfoAggiuntive}
                            setTipoAttoCessioneAffAzienda = {setTipoAttoCessioneAffAzienda}
                            TipoAttoCessioneAffAzienda = {TipoAttoCessioneAffAzienda}
                            setPrezzoVendita = {setPrezzoVendita}
                            setCanoneAffitto = {setCanoneAffitto}
                        />
                    );
                }

                if (tipoAtto === 'Testamenti') {
                    return (
                        <Testamenti 
                            setElencoPatrimonio = {setElencoPatrimonio}
                            setElencoEredi = {setElencoEredi}
                            ElencoPatrimonio = {ElencoPatrimonio}
                            ElencoEredi = {ElencoEredi}
                            setInfoAggiuntive = {setInfoAggiuntive}
                        />
                    );
                }

                if (tipoAtto === 'Fondo patrimoniale/Trust') {
                    return (
                        <FondoTrust 
                            setElencoBeni = {setElencoBeni}
                            ElencoBeni = {ElencoBeni}
                            setValoreAppBeni = {setValoreAppBeni}
                            setInfoAggiuntive = {setInfoAggiuntive}
                        />
                    );
                }
                
                if (tipoAtto === 'Altro') {
                    return (
                        <Altro 
                            setInfoPerPreventivo = {setInfoPerPreventivo}
                        />
                    );
                }
            })()}
            </MDBRow>						
            </>
	);
}